import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { CheckboxModule } from 'primeng/checkbox';
import { FormsModule } from '@angular/forms';
import { PasswordModule } from 'primeng/password';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { InputTextModule } from 'primeng/inputtext';
import { MenuModule } from 'primeng/menu';
import { TabViewModule } from 'primeng/tabview';
import { MessageService } from 'primeng/api';
import { ToastModule } from 'primeng/toast';
import { TableModule } from 'primeng/table';
import { RatingModule } from 'primeng/rating';
import { SliderModule } from 'primeng/slider';
import { CalendarModule } from 'primeng/calendar';
import { InputMaskModule } from 'primeng/inputmask';
import { ToggleButtonModule } from 'primeng/togglebutton';
import { RippleModule } from 'primeng/ripple';
import { MultiSelectModule } from 'primeng/multiselect';
import { DropdownModule } from 'primeng/dropdown';
import { ProgressBarModule } from 'primeng/progressbar';
import { FieldsetModule } from 'primeng/fieldset';
import { ConfirmPopupModule } from 'primeng/confirmpopup';
import { FileUploadModule } from 'primeng/fileupload';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { ListboxModule } from 'primeng/listbox';
import { ChipsModule } from 'primeng/chips';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { CardModule } from 'primeng/card';
import { UiSettingsComponent } from '../components/ui-settings/ui-settings.component';
import { PhonePipe } from '../pipes/phone.pipe';
import { InputSwitchModule } from 'primeng/inputswitch';

const primengComponents = [
  TableModule,
  RatingModule,
  ButtonModule,
  SliderModule,
  CalendarModule,
  InputTextModule,
  InputTextareaModule,
  InputMaskModule,
  ToggleButtonModule,
  RippleModule,
  MultiSelectModule,
  DropdownModule,
  ProgressBarModule,
  MenuModule,
  ToastModule,
  DialogModule,
  FieldsetModule,
  TabViewModule,
  ConfirmPopupModule,
  FileUploadModule,
  OverlayPanelModule,
  CheckboxModule,
  ListboxModule,
  PasswordModule,
  ChipsModule,
  AutoCompleteModule,
  ProgressSpinnerModule,
  CardModule,
  InputSwitchModule,
  UiSettingsComponent
]

const modules = [
  CommonModule,
  RouterModule,
  FormsModule,
  ...primengComponents,
  PhonePipe
];
const components = [];

@NgModule({
  declarations: [
    ...components
  ],
  imports: [...modules],
  exports: [
    ...modules,
    ...components
  ],
  providers: [
    MessageService
  ]
})
export class PanelModule { }
